import headerTheme from './headerTheme';
import { baseDarkTheme } from '~base-theme';
var headerDarkTheme = {
  header: Object.assign({}, headerTheme.header, {
    backgroundColor: baseDarkTheme.base.colors.light,
    shadow: {
      horizontalShadow: '0 4px 8px rgba(0,0,0,0.5)',
      verticalShadow: '6px 0 8px rgba(0,0,0,0.5)'
    }
  })
};
export default headerDarkTheme;